module.exports = __webpack_public_path__ + "static/media/clean.pass.covid.18d22b8c.png";